<template>
  <div class="clearfix">
    <!-- 单张图片 -->
    <template v-if="count === 1 && isUpload">
      <div class="uplaod_r">
        <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUpload"
        >
          <img v-if="imageUrl" :src="imageUrl.startsWith('http') ? imageUrl : $url + imageUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <!-- <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload> -->
        <span class="uplaod_f" v-if="type != 'video'">{{ autoCropWidths }}*{{ autoCropHeights }}</span>
      </div>
    </template>
    <template v-else-if="count === 1 && !isUpload">
      <div class="uplaod_r">
        <!-- <a-upload
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          :action="uploadImgUrl"
          @change="handleChange"
        >
          <img v-if="imageUrl" :src="imageUrl.startsWith('http') ? imageUrl : $url + imageUrl" alt="avatar" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload> -->
        <a-upload
          :before-upload="beforeUpload"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :customRequest="customRequest"
          :accept="type == 'video' ? '.mp4' : '.jpg,.png,.gif'"
        >
          <video controls v-if="type == 'video' && imageUrl">
            <source :src="imageUrl.startsWith('http') ? imageUrl : $url + imageUrl" type="video/mp4" />
          </video>
          <img
            v-else-if="imageUrl"
            :src="imageUrl.startsWith('http') ? imageUrl : $url + imageUrl"
            alt="avatar"
            @error="
              (e) => {
                e.target.src = errorImage
              }
            "
          />

          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <!-- <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload> -->
        <span class="uplaod_f" v-if="type != 'video' && showVal">{{ autoCropWidths }}*{{ autoCropHeights }}</span>
      </div>
    </template>
    <!-- 多图 -->
    <template v-else>
      <div class="uplaod_r">
        <a-upload
          class="avatar-uploader"
          :show-upload-list="true"
          :file-list="innerFileList"
          :list-type="type == 'image' ? 'picture-card' : 'picture'"
          :action="uploadImgUrl"
          :before-upload="beforeUpload"
          :headers="headers"
          :customRequest="customRequest"
          @change="changeImg"
          :showUploadList="{
            showRemoveIcon: true,
            showPreviewIcon: true,
          }"
          multiple
        >
          <div v-if="type == 'file' || type == 'video'">
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </div>
          <div v-if="!disabled && fileList.length < count">
            <span v-if="type == 'image'">
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </span>
          </div>
        </a-upload>
        <span class="uplaod_f" v-if="type != 'video'">{{ autoCropWidth }}*{{ autoCropHeight }}</span>
      </div>
    </template>
    <span v-if="value && type == 'file'">
      <br />
      <a :href="value" target="_blank">{{ value }}</a>
    </span>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img
        alt="example"
        style="width: 100%"
        :src="previewImage"
        @error="
          (e) => {
            e.target.src = errorImage
          }
        "
      />
    </a-modal>
    <caijian
      ref="caijian"
      @ok="handleOk"
      :autoCropWidth="autoCropWidth"
      :autoCropHeight="autoCropHeight"
      :visible="visibleCai"
      :fileName="fileName"
    ></caijian>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import caijian from './caijian.vue'
import { uploadAvatar, ossSignature, ossSigkey } from '@/api/system/user'
// import UploadFileToOSS from '@/utils/upload-file-to-oss.js'
import axios from 'axios'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
export default {
  name: 'ImageUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showVal: {
      type: Boolean,
      default: true,
    },
    isUpload: {
      type: Boolean,
      default: true,
    },
    isSize: {
      type: Boolean,
      default: false,
    },
    pathSrc: {
      type: String,
      default: '',
    },
    file: {
      type: [String, Array],
      default: null,
    },
    value: {
      type: String,
      default: '',
    },
    // 上传的文件类型 image图片 file文件
    type: {
      type: String,
      default: 'image',
    },
    autoCropWidth: {
      type: [String, Number],
      default: '200',
    },
    autoCropHeight: {
      type: [String, Number],
      default: '200',
    },
    count: {
      type: Number,
      default: 1,
    },
    defaultList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: { caijian },
  computed: {
    // 完全由父级 prop 计算得出，组件内不再维护
    innerFileList: {
      get() {
        const src = Array.isArray(this.file) ? this.file : []
        return src.map((url, idx) => ({
          uid: `${idx}-${url}`, // 保证唯一
          name: url.split('/').pop() || 'image',
          status: 'done',
          url: url.startsWith('http') ? url : this.$url + url,
        }))
      },
      set(newArr) {
        // 父级 v-model 会走到这里
        this.$emit(
          'input',
          newArr.map((item) => item.uid)
        )
      },
    },
  },

  created() {
    this.autoCropHeights = this.autoCropHeight + ''
    this.autoCropWidths = this.autoCropWidth + ''
    if (this.file) {
      if (this.count == 1) {
        this.imageUrl = this.file
      } else {
        const arr = []
        this.file.forEach((v) => {
          arr.push({ uid: v, url: this.$url + v })
        })
        this.fileList = arr
      }
    }
  },
  mounted() {},
  data() {
    return {
      loading: false,
      open: false,
      visibleCai: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      autoCropWidths: null,
      autoCropHeights: null,
      fileName: '',
      imageUrl: '',

      uploadImgUrl: process.env.VUE_APP_BASE_API + '/common/local/file/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
      },
      previewVisible: false,
      previewImage: '',
      fileList: [],
      // fileList: [
      // {
      //   "uid": "72968121",
      //   "name": "5938e139-d83d-4b50-b900-614154d6043e.png",
      //   "status": "done",
      //   "path": "https://static.xiaoxinxin.com/2023-08-10/5938e139-d83d-4b50-b900-614154d6043e.png",
      //   "url": "https://static.xiaoxinxin.com/2023-08-10/5938e139-d83d-4b50-b900-614154d6043e.png",
      //   "cover": ""
      // },
      // {
      //   uid: '-1',
      //   name: 'image.png',
      //   status: 'done',
      //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
      // },
      // ]
    }
  },
  methods: {
    beforeUpload(file) {
      // 文件类型(file.type)、大小限制(file.size)
      if (this.isUpload) {
        // const reader = new FileReader()
        // 把Array Buffer转化为blob 如果是base64不需要
        // 转化为base64
        // reader.readAsDataURL(file)
        // reader.onload = () => {
        //   this.options.img = reader.result
        // }
        // this.fileName = file.name
        // // 转化为blob
        // // reader.readAsArrayBuffer(file)
        // return false
        this.$nextTick(() => {
          this.$refs.caijian.beforeUpload(file)
        })
        return false
      } else {
        return new Promise((resolve, reject) => {
          // 视频类型直接放行（无需像素判断）
          if (this.type === 'video') {
            resolve(true)
            return
          }

          const img = new Image()
          img.onload = () => {
            const width = img.width
            const height = img.height
            const minWidth = Number(this.autoCropWidth)
            const minHeight = Number(this.autoCropHeight)
            if (minWidth && minHeight && this.isSize) {
              if ((minWidth && width !== minWidth) || height !== minHeight) {
                // 提示错误，reject 中断上传（不会进入 customRequest）
                this.$message.error(`图片像素尺寸过小，请上传 ${minWidth}*${minHeight} 及以上的图片`)
                reject(false) // 中断流程
              } else {
                // 像素合格，放行上传（进入 customRequest）
                resolve(true)
              }
              URL.revokeObjectURL(img.src)
            } else {
              if (width / height == 2 && width > 1000) {
                const originalFileName = file.name
                const fileNameWithoutExt = originalFileName.substring(0, originalFileName.lastIndexOf('.'))
                const fileExt = originalFileName.substring(originalFileName.lastIndexOf('.') + 1)
                this.$emit('backName', fileNameWithoutExt)
                resolve(true)
              } else {
                if (minHeight) {
                  resolve(true)
                } else {
                  this.$message.error('请上传正确的全景图片')
                  reject(false)
                }
              }
            }
          }
          img.onerror = () => {
            this.$message.error('无法读取图片信息，请重新选择')
            reject(false)
          }
          img.src = URL.createObjectURL(file)
        })
      }
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/IMG_${ymd}_${r}.${ext}`
      return cosKey
    },
    camSafeUrlEncode(str) {
      return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
    },
    init(w, h) {
      this.autoCropWidths = w
      this.autoCropHeights = h
    },
    customRequest(options) {
      const that = this
      that.loading = true
      const { file, onProgress, onSuccess, onError } = options
      var lastIndex = file.name.lastIndexOf('.')
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      const path = this.pathSrc ? this.pathSrc : this.$cosUrl
      const cosKey = this.generateCosKey(path, extName)
      const fileNames = cosKey.split('/').pop()

      ossSignature().then((res) => {
        res = res.data
        const cos = new COS({
          SecretId: res.tmpSecretId,
          SecretKey: res.tmpSecretKey,
          SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
          StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
          ExpiredTime: res.expiredTime, // 临时密钥过期时间
        })
        // const PicOperations = JSON.stringify({
        //   is_pic_info: 1, // 是否返回原图信息
        //   rules: [
        //     {
        //       fileid: 'desample_photo.jpg', // 处理后的文件名
        //       rule: 'imageMogr2/format/avif', // 图片处理规则
        //     },
        //   ],
        // })
        // const PicOperations = JSON.stringify({
        //   is_pic_info: 1, // 返回图片信息
        //   rules: [
        //     {
        //       fileid: cosKey, // 压缩后的文件名
        //       rule: 'imageSlim', // 启用极智压缩
        //     },
        //   ],
        // })
        const headers = {
          // 通过 imageMogr2 接口进行 jpg 压缩
          'Pic-Operations': JSON.stringify({
            is_pic_info: 1, // 返回图片信息
            rules: [
              {
                fileid: cosKey, // 压缩后的文件名
                rule: 'imageMogr2/quality/33', // 启用极智压缩
              },
            ],
          }),
        }
        // const obj = {
        //   Bucket: this.$Bucket, // 对象存储桶名称
        //   Region: 'ap-beijing', // 地域
        //   Key: cosKey, // 文件路径
        //   Body: file, // 文件对象
        //   Headers: headers,
        //   SliceSize:
        //     1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
        //   onProgress: function (progressData) {},
        // }
        const obj = {
          Bucket: this.$Bucket, // 对象存储桶名称
          Region: 'ap-beijing', // 地域
          Key: cosKey, // 文件路径
          Body: file, // 文件对象
          SliceSize:
            1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {},
        }
        if (this.type !== 'video') {
          obj.Headers = headers
        }
        cos.putObject(obj, function (err, data) {
          if (err) {
            that.loading = false
          } else {
            that.loading = false

            that.handleOk(cosKey)
          }
        })
      })
    },
    handleOk(e) {
      if (this.count === 1) {
        this.imageUrl = e
        this.$emit('input', e)
      } else {
        this.fileList.push({ uid: e, url: this.$url + e })
        let arr = []
        arr = this.fileList.map((v) => (v = v.uid))
        this.$emit('input', arr)
      }
    },
    async handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.code !== '20001') {
          this.$message.error('上传失败' + info.file.response.msg)
          this.loading = false
          return
        }
        this.loading = false
        this.visibleCai = true
        this.imageUrl = info.file.response.data

        this.$emit('input', info.file.response.url)
      }
      // this.loading = true
      // new UploadFileToOSS([info.file], {
      //   finally: (res) => {
      //     this.loading = false
      //     this.fileList = this.fileList.concat(res)
      //   },
      // })
    },
    changeImg({ file, fileList }) {
      // {
      //   "file": {
      //       "uid": "48718960",
      //       "name": "aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "status": "removed",
      //       "path": "https://static.xiaoxinxin.com/2023-08-10/aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "url": "https://static.xiaoxinxin.com/2023-08-10/aaa002fd-22dc-4e42-9f56-8335ed3e8e92.png",
      //       "cover": ""
      //   },
      //   "fileList": []
      // }
      if (file.status === 'removed') {
        this.$emit(
          'input',
          fileList.map((f) => f.uid)
        )

        if (this.count === 1) {
          this.fileList = []
        } else {
          const index = this.fileList.findIndex((ele) => ele.uid === file.uid)
          this.fileList.splice(index, 1)
          const arr = this.fileList.map((v) => v.uid)
          this.$emit('input', arr)
        }
        this.$forceUpdate()
      }
    },
    /** 图片预览 */
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
  },
}
</script>
<style lang="less" scoped>
img {
  width: 128px;
  height: 128px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.uplaod_r {
  position: relative;
  .uplaod_f {
    position: absolute;
    left: 0;
    bottom: -15px;
  }
}
video {
  width: 100px;
  height: 100px;
}
</style>
